import React from "react";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import S from "./NoPrice.module.scss";

interface DA_EmptyStateNoPriceProps {
    className?: string;
    small?: boolean;
}

export const DA_EmptyStateNoPrice = ({ className, small }: DA_EmptyStateNoPriceProps) => {
    const { getDictionaryString } = useTranslations();

    return (
        <div className={cn(S.noPriceText, small && S.small, className && className)}>
            {getDictionaryString("general.noPrice")}
        </div>
    );
};
